<template>
  <b-modal
    id="kompack-modal-partner-detail"
    title="Detail Partner"
    size="lg"
    centered
    hide-footer
    hide-header
    hide-header-close
  >
    <div>
      <div class="flex items-center justify-start gap-[12px] mt-[8px]">
        <button
          class="button-primary"
          @click="hide"
        >
          <img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/arrow-left-2.svg"
            alt="arrow left"
          >
        </button>
        <div class="text-black text-[16px]">
          Detail Partner: <span class="font-semibold">{{ partnerName }}</span>
        </div>
      </div>
      <div
        v-if="isLoading"
        class="flex items-center justify-center gap-[8px] min-h-[460px]"
      >
        <b-spinner variant="primary" /> Memuat data...
      </div>
      <div
        v-else
        class="my-[24px] mb-[18px] text-black min-h-[400px]"
      >
        <h4 class="mx-[16px] mt-[16px] mb-[8px] text-[16px] text-black">
          Informasi Umum
        </h4>
        <div class="bg-gray-100 rounded-[8px] p-[16px]">
          <div class="mb-[8px] flex lg:items-center flex-col lg:flex-row gap-[8px]">
            <p class="text-black/70 w-[250px]">
              Alamat Pengguna
            </p>
            <p>: {{ data.partner_address || '-' }}</p>
          </div>
          <div class="mb-[8px] flex lg:items-center flex-col lg:flex-row gap-[8px]">
            <p class="text-black/70 w-[250px]">
              Alamat Bisnis
            </p>
            <p>: {{ data.business_address || '-' }}</p>
          </div>
          <div class="mb-[8px] flex lg:items-center flex-col lg:flex-row gap-[8px]">
            <p class="text-black/70 w-[250px]">
              Apakah sudah tanda tangan MoU?
            </p>
            <p class="flex items-center gap-[4px]">:
              <span
                class="w-[14px] h-[14px] rounded-full block"
                :class="isSignedMoU.class"
              />{{ isSignedMoU.text }}</p>
          </div>
          <div class="mb-[8px] flex lg:items-center flex-col lg:flex-row gap-[8px]">
            <p class="text-black/70 w-[250px]">
              Tanggal Registrasi:
            </p>
            <p>: {{ registrationDate }}</p>
          </div>
          <div class="mb-[8px] flex lg:items-center flex-col lg:flex-row gap-[8px]">
            <p class="text-black/70 w-[250px]">
              Tanggal Last Packing:
            </p>
            <p>: {{ lastPackingDate }}</p>
          </div>
        </div>
        <h4 class="mb-[8px] mt-[26px] pt-[16px] mx-[16px] text-[16px] text-black border-t border-gray-600 border-dashed">
          Transaksi
        </h4>
        <div class="bg-gray-100 rounded-[8px] p-[16px] [&>div]:mb-[6px]">
          <div class="flex items-start justify-between sm:flex-row flex-col gap-[2px]">
            <p>Transaksi Biaya Penarikan</p>
            <p>{{ data.item_withdrawal_tx | rupiah }}</p>
          </div>
          <div class="flex items-start justify-between sm:flex-row flex-col gap-[2px]">
            <p>Revenue Kompack dari Biaya Penarikan</p>
            <p>{{ data.item_withdrawal_revenue_tx | rupiah }}</p>
          </div>
          <div class="flex items-start justify-between sm:flex-row flex-col gap-[2px]">
            <p>Transaksi Biaya Low Moving Stock</p>
            <p>{{ data.low_moving_stock_tx | rupiah }}</p>
          </div>
          <div class="flex items-start justify-between sm:flex-row flex-col gap-[2px]">
            <p>Revenue Kompack dari Biaya Low Moving Stock</p>
            <p>{{ data.low_moving_stock_revenue_tx | rupiah }}</p>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { DAY_MONTH_YEAR } from '@/libs/filterDate'

/**
 * Modal Detail Partner
 */
export default {
  data() {
    return {
      partnerName: '',
      idItem: 0,
      isLoading: true,
      data: {},
    }
  },
  computed: {
    registrationDate() {
      if (!this.data.register) {
        return '-'
      }
      return DAY_MONTH_YEAR(this.data.register)
    },
    lastPackingDate() {
      if (!this.data.last_packing) {
        return '-'
      }
      return DAY_MONTH_YEAR(this.data.last_packing)
    },
    isSignedMoU() {
      if (this.data.mou) {
        return {
          class: 'bg-green-500',
          text: 'Ya',
        }
      }
      return {
        class: 'bg-red-500',
        text: 'Tidak',
      }
    },
  },
  methods: {
    /**
     * Show Modal Detail Partner
     * @param {number} id
     * @param {string} partnerName
     */
    show(id, partnerName) {
      if (id !== this.idItem) {
        this.partnerName = partnerName
        this.idItem = id
        this.fnFetchData()
      }
      this.$bvModal.show('kompack-modal-partner-detail')
    },
    /**
     * Hide Modal Detail Partner
     */
    hide() {
      this.$bvModal.hide('kompack-modal-partner-detail')
    },
    /**
     * Fetch Data Partner
     */
    async fnFetchData() {
      this.isLoading = true
      try {
        const { data } = await this.$http_new.get(`/kompack/api/v1/dashboard/admin/partners/${this.idItem}/details`)
        this.data = data.data
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data partner' })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
